export default __webpack_public_path__ + "static/media/carousel-1.183d96f8.png";